const htmlInnerContentSelectReg = /<[^>]*>/g;

export const doesHtmlHaveContent = (html: string): boolean => !!html.replace(htmlInnerContentSelectReg, '').length;

type SeparatorProps = {
  char: string,
  oneWhiteSpace?: boolean,
  oneSpaceBeforeChar?: boolean,
}

export const createCharacterSeparator = (props: SeparatorProps): (str: string) => string => {
  const {
    char,
    oneWhiteSpace,
    oneSpaceBeforeChar
  } = props
  const pattern = new RegExp(`(?<=\\S)${char}(?=\\S)`, 'g');
  const oneSpaceReplaceValue = oneSpaceBeforeChar ? ` ${char}` : `${char} `;
  const replaceValue = oneWhiteSpace ? oneSpaceReplaceValue : ` ${char} `
  return (str: string): string => str.replace(pattern, replaceValue);
}

/**
 * Sanitizes a filename for use in URLs and file systems
 * - Trims whitespace
 * - Replaces spaces with hyphens
 * - Converts to lowercase
 * - Removes consecutive hyphens
 * @param filename - The filename to sanitize
 * @returns The sanitized filename
 */
export const sanitizeFilename = (filename: string): string => {
  if (!filename || typeof filename !== 'string') {
    return '';
  }

  return filename
    .trim()
    .replace(/\s+/g, '-')  // Replace spaces with hyphens
    .toLowerCase()         // Convert to lowercase
    .replace(/-+/g, '-');  // Remove consecutive hyphens
}

/**
 * Converts a camelCase or PascalCase string to a space-separated string
 * @param text The camelCase or PascalCase string to convert
 * @returns A string with spaces before capital letters (except the first one)
 */
export const convertCamelCaseToSpaced = (text?: string): string => {
  if (!text) return '';

  // Add space before capital letters (except the first one)
  return text.replace(/([A-Z])/g, (match, p1, offset) => {
    return offset === 0 ? p1 : ' ' + p1;
  });
};

// normalizes long file names:
export const normalizeFileName = (fileName: string, maxLength: number = 35): string => {
  if (!fileName) return '';

  // Truncate the file name if it exceeds the maximum length
  if (fileName.length > maxLength) {
    const extensionIndex = fileName.lastIndexOf('.');
    const extension = extensionIndex !== -1 ? fileName.slice(extensionIndex) : '';
    const baseName = fileName.slice(0, maxLength - extension.length);
    return baseName + extension;
  }

  return fileName;
};